<template>
  <div
    id="register_component"
    class="_main_container _register_bg"
  >

    <div class="_register_header">
      <div class="_register_header_container">
        <img src="~images/logo_normal.svg">
        <b>注册账号</b>
        <a href="login.html">登录</a>
      </div>
    </div>

    <div style="height:40px;">&nbsp;</div>

    <div class="_operate_step">
      <table
        cellpadding="0"
        cellspacing="0"
        border="0"
        width="100%"
      >
        <colgroup>
          <col width="33%">
          <col width="34%">
          <col width="33%">
        </colgroup>
        <tr>
          <td :class="{_ok:step1}">
            <span class="_step_dot">1</span>
          </td>
          <td :class="{_ok:step2}">
            <span class="_step_dot">2</span>
          </td>
          <td :class="{_ok:step3}">
            <span class="_step_dot">3</span>
          </td>
        </tr>
        <tr>
          <th>创建账号</th>
          <th>创建企业</th>
          <th>创建成功</th>
        </tr>
      </table>
    </div>

    <div style="height:40px;">&nbsp;</div>

    <div
      class="_register_frame"
      v-if="step1"
      style="width: 540px; padding: 20px 0"
    >
      <div class="_register_form_container">
        <p class="_common_form_row">
          <label>用户姓名</label>
          <input
            :class="{_er:v_name}"
            type="text"
            placeholder="输入用户姓名"
            v-model.trim="parameters1.name"
            @keyup.enter="enterSubmit()"
            @focus="focusInput('name')"
            @blur="blurInput('name')"
          >
          <span
            v-if="v_name"
            class="_common_form_row_tips"
          >请输入用户姓名</span>
        </p>
        <p class="_common_form_row">
          <label>手机号码</label>
          <input
            :class="{_er:v_mobile}"
            type="text"
            placeholder="输入手机号码"
            maxlength="11"
            v-model.trim="parameters1.mobile"
            @keyup.enter="enterSubmit()"
            @focus="focusInput('mobile')"
            @blur="blurInput('mobile')"
          >
          <span
            v-if="v_mobile"
            class="_common_form_row_tips"
          >输入正确格式的手机号码</span>
        </p>
        <p class="_common_form_row">
          <label>手机验证码</label>
          <input
            id="verifyCode"
            :class="{_er:v_verifyCode}"
            type="text"
            placeholder="输入手机验证码"
            maxlength="6"
            v-model.trim="parameters1.verifyCode"
            @keyup.enter="enterSubmit()"
            @focus="focusInput('verifyCode')"
            @blur="blurInput('verifyCode')"
          >
          <button
            v-show="mobile_countDown_show"
            @click="getVerifyCode('mobile')"
          >获取验证码</button>
          <button
            v-show="!mobile_countDown_show"
            class="_disabled"
          >{{mobile_countDown}}秒后重新获取</button>
          <span
            v-if="v_verifyCode && v_r_code===0"
            class="_common_form_row_tips"
          >输入手机验证码</span>
          <span
            v-if="v_r_code===1"
            class="_common_form_row_tips"
          >手机验证码错误</span>
        </p>
        <p class="_common_form_row">
          <label>登录密码</label>
          <input
            :class="{_er:v_password1}"
            type="password"
            placeholder="由6-18位字母/数字/下划线组成"
            maxlength="18"
            v-model.trim="parameters1.password1"
            @keyup.enter="enterSubmit()"
            @focus="focusInput('password1')"
            @blur="blurInput('password1')"
          >
          <span
            v-if="v_password1"
            class="_common_form_row_tips"
          >密码由6-18位字母/数字/下划线组成</span>
        </p>
        <p class="_common_form_row">
          <label>确认密码</label>
          <input
            :class="{_er:v_password2 || v_pwd1_pwd2}"
            type="password"
            placeholder="由6-18位字母/数字/下划线组成"
            maxlength="18"
            v-model.trim="parameters1.password2"
            @keyup.enter="enterSubmit()"
            @focus="focusInput('password2')"
            @blur="blurInput('password2')"
          >
          <span
            v-if="v_password2 && !v_pwd1_pwd2"
            class="_common_form_row_tips"
          >密码由6-18位字母/数字/下划线组成</span>
          <span
            v-if="v_pwd1_pwd2"
            class="_common_form_row_tips"
          >两次输入密码不一致</span>
        </p>
        <p class="_common_form_row_xy">
          <input
            type="checkbox"
            checked="checked"
            v-model="agreeRegister"
          >
          <span>
            我已阅读并同意
            <a
              href="https://i.banmalaila.com/privacy/privacy.html"
              target="_blank"
            >《隐私协议》</a>
          </span>
        </p>
        <div class="_common_button">
          <a
            v-if="agreeRegister"
            href="javascript:;"
            @click="submit()"
          >下一步</a>
          <a
            v-if="!agreeRegister"
            href="javascript:;"
            class="_disabled"
          >下一步</a>
        </div>
      </div>
    </div>

    <div
      class="_register_frame step2"
      v-if="step2"
      style="width: 560px"
    >
      <div class="_register_form_container">

        <table
          cellspacing="0"
          cellpadding="0"
          border="0"
          class="_verified_upload_image"
        >

          <tr>
            <td
              valign="top"
              width="25%"
            >营业执照</td>

            <td valign="top">
              上传清晰、端正、平整的营业执照原件或加盖公章的复印件照片
              <span
                v-if="v_corpPic"
                class="_common_form_row_tips"
                style="left:250px;top:53%;"
              >上传营业执照</span>
            </td>
          </tr>

          <tr>
            <td>&nbsp;</td>
            <td style="padding: 10px 0px;">

              <span class="_file_container">
                <img src="~images/dynamic/upload_image_sample_s101.jpg">
                <b style="color:#fff;">
                  <i class="fa fa-photo"></i>
                  <br>示例
                </b>
              </span>

              <span
                v-viewer
                v-for="(picUrl,i) in parameters.picUrls"
                class="_file_container"
              >
                <img
                  :src="picUrl.temPicUrl"
                  @click="showThisImg(picUrl.temPicUrl)"
                >
                <i @click="removeThisImg(i)">&times;</i>
              </span>

              <span
                v-if="!parameters.picUrls[0]"
                class="_file_container"
                title="点击上传图片"
              >
                <b>
                  <i class="fa fa-upload"></i>
                  <br>上传
                </b>
                <input
                  id="pic_file"
                  type="file"
                  @change="uploadImage()"
                >
              </span>

            </td>
          </tr>
        </table>

        <div class="_common_form_row">
          <label>企业名称</label>
          <input
            :class="{_er:v_corpName}"
            id="corpName"
            type="text"
            placeholder="必须与营业执照上名称一致"
            maxlength="30"
            v-model.trim="parameters.corpName"
            @focus="focusInput('corpName')"
            @blur="blurInput2('corpName')"
            disabled="disabled"
          >
          <span
            v-if="v_corpName"
            class="_common_form_row_tips"
          >输入正确格式的企业名称</span>
        </div>

        <div class="_common_form_row">
          <label>信用代码或注册号</label>
          <input
            :class="{_er:v_corpPinNo}"
            id="corpPinNo"
            type="text"
            placeholder="社会统一信用代码或注册号"
            maxlength="18"
            v-model.trim="parameters.corpPinNo"
            @focus="focusInput('corpPinNo')"
            @blur="blurInput2('corpPinNo')"
            disabled="disabled"
          >
          <span
            v-if="v_corpPinNo"
            class="_common_form_row_tips"
          >只支持数字和字母的组合,检查!</span>
        </div>

        <div class="_common_form_row">
          <label>企业所在地</label>

          <b
            class="_common_select"
            style="width: 25%;"
          >
            <select
              id="s1v"
              v-model="s1v"
            >
              <option
                value="0"
                selected="selected"
              >直辖市/省</option>
              <option
                v-for="i in s1tL"
                :value="i[1]"
              >{{i[2]}}</option>
            </select>
          </b>

          <b
            class="_common_select"
            style="width: 24%; margin-left: 1%;"
          >
            <select
              id="s2v"
              v-model="s2v"
            >
              <option
                value="0"
                selected="selected"
              >直辖市/市</option>
              <option
                v-for="i in s2tL"
                :value="i[1]"
              >{{i[2]}}</option>
            </select>
          </b>

          <b
            class="_common_select"
            style="width: 24%; margin-left: 1%;"
          >
            <select
              id="s3v"
              v-model="s3v"
            >
              <option
                value="0"
                selected="selected"
              >市辖区/县</option>
              <option
                v-for="i in s3tL"
                :value="i[1]"
              >{{i[2]}}</option>
            </select>
          </b>

          <span
            v-if="v_pcz"
            class="_common_form_row_tips"
          >选择企业所在地</span>

        </div>

        <div class="_common_form_row">
          <label>详细地址</label>
          <input
            :class="{_er:v_adr}"
            type="text"
            placeholder="详细地址(xxx路xxx号xxx室)"
            maxlength="48"
            v-model.trim="adr"
            @focus="focusInput('adr')"
            @blur="blurInput2('adr')"
          >
          <span
            v-if="v_adr"
            class="_common_form_row_tips"
          >输入详细的企业地址</span>
        </div>

        <table
          cellspacing="0"
          cellpadding="0"
          border="0"
          class="_verified_upload_idcard_pic"
        >

          <tr>
            <td
              valign="top"
              width="25%"
            >法人身份证</td>

            <td valign="top">
              上传清晰、端正的身份证正反面照片
              <span
                v-if="v_idCardPic"
                class="_common_form_row_tips"
                style="left:310px;top:53%;"
              >上传清晰、端正的身份证正反面照片</span>
            </td>
          </tr>

          <tr>
            <td>&nbsp;</td>
            <td style="padding: 10px 0px;">

              <span
                v-viewer
                v-if="!!idCardPic_1.picUrl"
                class="_file_container"
              >
                <img :src="idCardPic_1.picUrl" />
                <i @click="removeLegalPersonImage(1)">&times;</i>
              </span>

              <span
                v-if="!idCardPic_1.picUrl"
                class="_file_container"
              >
                <img src="~images/dynamic/sample_img_idcard_1.png" />
                <b><i class="fa fa-upload"></i><br />上传头像面</b>
                <input
                  id="pic_file_1"
                  type="file"
                  @change="uploadIdCardPic(1)"
                />
              </span>

              <span
                v-viewer
                v-if="!!idCardPic_2.picUrl"
                class="_file_container"
              >
                <img :src="idCardPic_2.picUrl" />
                <i @click="removeLegalPersonImage(2)">&times;</i>
              </span>

              <span
                v-if="!idCardPic_2.picUrl"
                class="_file_container"
              >
                <img src="~images/dynamic/sample_img_idcard_2.png" />
                <b><i class="fa fa-upload"></i><br />上传国徽面</b>
                <input
                  id="pic_file_2"
                  type="file"
                  @change="uploadIdCardPic(2)"
                />
              </span>

            </td>
          </tr>
        </table>

        <div class="_common_form_row">
          <label>法人姓名</label>
          <input
            :class="{_er:v_legalPersonName}"
            id="legalPersonName"
            type="text"
            placeholder="请输入法人姓名"
            maxlength="30"
            v-model.trim="parameters.legalPersonName"
            @focus="focusInput('legalPersonName')"
            @blur="blurInput2('legalPersonName')"
            disabled="disabled"
          >
          <span
            v-if="v_legalPersonName"
            class="_common_form_row_tips"
          >请输入法人姓名</span>
        </div>

        <div class="_common_form_row">
          <label>法人身份证号</label>
          <input
            :class="{_er:v_legalPersonIdCard}"
            id="legalPersonIdCard"
            type="text"
            placeholder="请输入法人身份证号"
            maxlength="30"
            v-model.trim="parameters.legalPersonIdCard"
            @focus="focusInput('legalPersonIdCard')"
            @blur="blurInput2('legalPersonIdCard')"
            disabled="disabled"
          >
          <span
            v-if="v_legalPersonIdCard"
            class="_common_form_row_tips"
          >请输入法人身份证号</span>
        </div>

        <div class="_common_form_row">
          <label>销售联系人</label>
          <input
            type="text"
            placeholder="没有可不填"
            maxlength="50"
            v-model.trim="parameters.saler"
          >
        </div>

        <p class="_common_form_row _verified_upload_image">
          <label>企业相关图片</label>
          <span
            v-for="(picUrl,i) in picRelativeArr"
            class="_file_container"
            :key="i"
          >
            <img
              :src="picUrl.temPicUrl"
              @click="showThisImg(picUrl.temPicUrl)"
            />
            <i @click="removeRelativeImg(i)">&times;</i>
          </span>

          <span
            class="_file_container"
            title="点击上传图片"
            v-if="picRelativeArr && picRelativeArr.length < 2"
          >
            <b><i class="fa fa-upload"></i><br />上传</b>
            <input
              id="pic_file_relative"
              type="file"
              @change="uploadRelativeImage()"
            />
          </span>
        </p>

        <div class="_common_button">
          <a
            href="javascript:;"
            @click="showConfirmSubmit()"
          >提交</a>
        </div>

        <div
          class="pass_btn"
          @click="gotoStep3"
        >暂不创建</div>

      </div>

      <div
        class="_user_alert_card"
        v-if="confirmSubmit"
      >&nbsp;</div>

      <div
        class="_user_alert_card_container"
        style="width:32%;left:34%;"
        v-if="confirmSubmit"
      >

        <i
          title="关闭"
          @click="closeConfirmSubmit()"
        >&times;</i>

        <h1>
          <img src="~images/icons/company.png">
          <span>提交前核对信息</span>
        </h1>

        <p style="text-align:left;padding:10px 0px 30px 0px;width:90%;">
          <span style="display: inline-block;width:32%;text-align:right;">企业名称:</span>
          <b style="color:#2f81e8;">{{parameters.corpName}}</b>
          <br>
          <span style="display: inline-block;width:32%;text-align:right;">信用代码/注册号:</span>
          <b style="color:#2f81e8;">{{parameters.corpPinNo}}</b>
        </p>

        <a @click="submit2()">确认无误</a>
        <b @click="closeConfirmSubmit()">返回修改</b>

      </div>
    </div>

    <div
      class="_register_frame"
      v-if="step3"
    >
      <div class="_register_form_container">
        <span class="_operate_result_icon">
          <i class="fa fa-check-circle"></i>
        </span>
        <b class="_operate_result_message">账号创建成功</b>
        <a
          class="_operate_result_jumper"
          :href="link_to"
        >
          <i>{{link_countDown}}</i>直接跳转&raquo;
        </a>
      </div>
    </div>

    <div style="height:40px;">&nbsp;</div>

    <PageFloatButtons></PageFloatButtons>

    <LoginVerify
      :is-show="loginVerifyShow"
      :validate="validate"
      :get-data="getDragVerification"
      @control="loginVerifyControl"
    ></LoginVerify>
  </div>
</template>
<script>
import LoginVerify from '../../component/loginVerify'
import PageFloatButtons from "component/public/PageFloatButtons.vue";
import Region from "js/region.js";
import { getDragVerification, checkAndSendVerifyCode } from "api/index";
//引入aliOSS模块,执行图片上传
var OSS = require("ali-oss");
var client = new OSS({
  region: "oss-cn-shanghai",
  accessKeyId: "LTAIMWQlWtFtZ2Dh",
  accessKeySecret: "UM02hyjoW4C2kEqYON5j42LlkTXX5s",
  bucket: "kk-oss"
});

let dataObj = {
  loginVerifyShow: false,//控制图形验证弹窗
  taskId: '',//图形验证任务id
  requestUrl: websiteConfig.commonRequestUrl,
  tkName: websiteConfig.tokenStringName,
  token: getLocalStorage(websiteConfig.tokenStringName),
  accountBaseInfo: {},
  step1: true,
  step2: false,
  step3: false,
  mobile_countDown: 60,
  mobile_countDown_show: true,
  link_countDown: 5,
  link_to: "user_index.html",
  parameters1: {
    name: "",
    mobile: "",
    password1: "",
    password2: "",
    verifyCode: ""
  },
  slide: false,
  // v_slide: false,
  v_name: false,
  v_mobile: false,
  v_password1: false,
  v_password2: false,
  v_pwd1_pwd2: false,
  v_verifyCode: false,
  v_r_code: 0,
  agreeRegister: true,
  v_corpPic: false,
  v_corpName: false,
  v_legalPersonName: false,
  v_legalPersonIdCard: false,
  v_idCardPic: false,
  v_corpPinNo: false,
  v_pcz: false,
  v_adr: false,
  s1v: "0",
  s2v: "0",
  s3v: "0",
  adr: "",
  legalPersonNameIdentify: '',
  idCardPic_1: {},
  idCardPic_2: {},
  parameters: {
    corpAuthId: "",
    corpName: "",
    legalPersonName: "",
    legalPersonIdCard: "",
    corpPinNo: "",
    oldCorpPinNo: "",
    location: {
      provinceCode: "",
      cityCode: "",
      zoneCode: "",
      address: ""
    },
    saler: "",
    picUrls: []
  },
  confirmSubmit: false,
  picRelativeArr: []
};
export default {
  data() {
    return dataObj;
  },
  components: {
    LoginVerify,
    PageFloatButtons
  },
  computed: {
    s1tL: function () {
      let regionList = Region.regionData;
      let id = "1";
      let vl = [];
      for (let i = 0; i < regionList.length; i++) {
        if (regionList[i][3] === id) {
          vl.push(regionList[i]);
        }
      }
      return vl;
    },
    s2tL: function () {
      let regionList = Region.regionData;
      let v = this.s1v;
      this.s2v = "0";
      if (v === "0") {
        return [];
      }
      let id = "";
      let vl = [];
      for (let i = 0; i < regionList.length; i++) {
        if (regionList[i][1] === v) {
          id = regionList[i][0];
          break;
        }
      }
      for (let i = 0; i < regionList.length; i++) {
        if (regionList[i][3] === id) {
          vl.push(regionList[i]);
        }
      }
      return vl;
    },
    s3tL: function () {
      let regionList = Region.regionData;
      let v = this.s2v;
      this.s3v = "0";
      if (v === "0") {
        return [];
      }
      let id = "";
      let vl = [];
      for (let i = 0; i < regionList.length; i++) {
        if (regionList[i][1] === v) {
          id = regionList[i][0];
          break;
        }
      }
      for (let i = 0; i < regionList.length; i++) {
        if (regionList[i][3] === id) {
          vl.push(regionList[i]);
        }
      }

      return vl;
    }
  },
  methods: {
    focusInput(ele) {
      let _this = this;
      _this["v_" + ele] = false;
    },
    blurInput(ele) {
      let _this = this;
      let value = _this.parameters1[ele];
      let validate = true;
      if (ele === "mobile") {
        validate = value.common_check_mobile();
      } else if (ele === "password1") {
        _this["v_password2"] = false;
        _this["v_pwd1_pwd2"] = false;
        validate = value.common_check_password();
        let v1 = _this.parameters1["password2"];
        if (validate && v1 !== "" && v1 !== value) {
          _this.v_pwd1_pwd2 = true;
        }
      } else if (ele === "password2") {
        _this["v_pwd1_pwd2"] = false;
        let v2 = _this.parameters1["password1"];
        validate = value.common_check_password();
        if (validate && v2 !== value) {
          validate = false;
          _this.v_pwd1_pwd2 = true;
        }
      } else {
        validate = value.required();
      }
      if (!validate) {
        _this["v_" + ele] = true;
      }
      return validate;
    },
    getVerifyCode(ele) {
      let _this = this;

      if (!_this.blurInput(ele)) {
        return false;
      }

      this.loginVerifyControl(true)
    },
    submit() {
      let _this = this;
      _this.v_r_code = 0;
      let reqData = _this.parameters1;
      let requestUrl = _this.requestUrl + "/user/regist/";
      if (!_this.blurInput("name")) {
        return false;
      }
      if (!_this.blurInput("mobile")) {
        return false;
      }
      if (!_this.blurInput("verifyCode")) {
        return false;
      }
      if (!_this.blurInput("password1")) {
        return false;
      }
      if (!_this.blurInput("password2")) {
        return false;
      }
      $.ajax({
        type: "POST",
        url: requestUrl,
        data: JSON.stringify(reqData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        beforeSend: function (request) {
          $.addWaiting("稍等");
          request.setRequestHeader("token", _this.token);
        },
        success: function (data) {
          let code = data.code;
          let msg = data.msg;
          let content = data.content;
          _this.v_r_code = code;
          if (code === 0) {
            _this.token = content.token;
            setLocalStorage(_this.tkName, _this.token);
            _this.step1 = false;
            _this.step2 = true;
            // let intervalObj = setInterval(function() {
            //     _this.link_countDown -= 1;
            //     if (_this.link_countDown <= 0) {
            //         _this.link_countDown = 5;
            //         clearInterval(intervalObj);
            //         window.location.href = _this.link_to;
            //     }
            // }, 1000);
          }
          $.removeWaiting();
        },
        error: function (error) {
          $.ajaxError(error);
        }
      });
    },
    enterSubmit() {
      let _this = this;
      _this.submit();
    },
    countDownFun(ele) {
      let _this = this;
      _this[ele + "_countDown_show"] = false;
      let intervalObj = setInterval(function () {
        _this[ele + "_countDown"] -= 1;
        if (_this[ele + "_countDown"] <= 0) {
          _this[ele + "_countDown"] = 60;
          _this[ele + "_countDown_show"] = true;
          clearInterval(intervalObj);
        }
      }, 1000);
    },
    initSlideVerOperate(domId) {
      let _this = this;
      var nc_token = [
        "CF_APP_1",
        new Date().getTime(),
        Math.random()
      ].join(":");
      var NC_Opt = {
        renderTo: "#" + domId,
        appkey: "CF_APP_1",
        scene: "register",
        token: nc_token,
        customWidth: "100%",
        trans: { key1: "code0" },
        elementID: ["usernameID"],
        is_Opt: 0,
        language: "cn",
        isEnabled: true,
        timeout: 3000,
        times: 5,
        apimap: {},
        callback: function (data) {
          _this[domId] = true;
          _this["v_" + domId] = false;
        }
      };
      var nc = new noCaptcha(NC_Opt);
      nc.upLang("cn", {
        _startTEXT: "按住滑块，拖动到最右边",
        _yesTEXT: "验证通过",
        _error300:
          '哎呀，出错了，点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
        _errorNetwork:
          '网络不给力，<a href="javascript:__nc.reset()">点击刷新</a>'
      });
    },
    uploadImage() {
      let _this = this;
      var uuid = getCommonId();
      var fileArr = document.getElementById("pic_file");
      var file = fileArr.files[0];
      var type = file.name.split('.')[1].trim().toLowerCase();
      if (type !== "jpg" && type !== "jpeg" && type !== "png" && type !== "gif" && type !== "bmp") {
        fileArr.value = "";
        $.userAlert("只能上传jpg、png、gif、bmp格式的图片");
        return false;
      }
      var maxSize = 20 * 1024 * 1024;//20M
      var fileSize = file.size;
      if (fileSize > maxSize) {
        fileArr.value = "";
        $.userAlert("上传的图片不能大于20M");
        return false;
      }
      var dateTime = Date.now().formatOnlyDate();
      var storeAs = 'customer/' + dateTime + '/' + uuid + '.' + type;
      $.addWaiting("稍等");
      client.multipartUpload(storeAs, file).then(function (result) {
        if (result.res.status === 200) {
          var _thisPicType = "BusinessLicenseFrontend";
          var _thisPicUrl = result.res.requestUrls[0];

          let requestUrl = _this.requestUrl + "/user/dealOssUrl";
          $.ajax({
            type: "GET",
            url: requestUrl,
            data: { ossUrl: _thisPicUrl },
            dataType: "json",
            contentType: "application/json; charset=utf-8",
            beforeSend: function (request) {
              request.setRequestHeader("token", dataObj.token);
            },
            success: function (data) {
              var _temPicUrl = data.content;
              var uploadImageInfoObj = {
                picType: _thisPicType,
                picUrl: _temPicUrl,
                temPicUrl: _temPicUrl
              };
              _this.parameters.picUrls.push(uploadImageInfoObj);
            },
            error: function (error) {
              $.ajaxError(error);
            }
          });
          var cName = "baiduApiIdentificationNumber" + _this.accountBaseInfo.mobile;
          var cNumber = !!getLocalStorage(cName) ? parseInt(getLocalStorage(cName)) : 1;
          if (cNumber > 5) {
            $("#corpName,#corpPinNo").removeAttr("disabled");
            $.removeWaiting();
          }
          else {
            //调用百度API识别营业执照信息
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function (e) {
              var base64Image = reader.result;
              var base64ImageShot = base64Image.substring(base64Image.indexOf(",") + 1);
              _this.baiduApiIdentification(base64ImageShot, cName, cNumber + 1);
            };
          }

        }
        else {
          $.userAlert("上传失败,重试!");
          return false;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    uploadIdCardPic(i) {

      let _this = this;
      var uuid = getCommonId();
      var fileArr = document.getElementById("pic_file_" + i);
      var file = fileArr.files[0];
      var type = file.name.split('.')[1].trim().toLowerCase();

      if (type !== "jpg" && type !== "jpeg" && type !== "png" && type !== "gif" && type !== "bmp") {
        fileArr.value = "";
        $.userAlert("只能上传jpg、png、gif、bmp格式的图片");
        return false;
      }

      var maxSize = 20 * 1024 * 1024;//20M
      var fileSize = file.size;
      if (fileSize > maxSize) {
        fileArr.value = "";
        $.userAlert("上传的图片不能大于20M");
        return false;
      }

      var dateTime = Date.now().formatOnlyDate();
      var storeAs = 'customer/' + dateTime + '/' + uuid + '.' + type;

      $.addWaiting("请稍等");
      client.multipartUpload(storeAs, file).then(function (result) {
        if (result.res.status === 200) {

          var _thisPicUrl = result.res.requestUrls[0];
          let requestUrl = _this.requestUrl + "/user/dealOssUrl";

          $.ajax({
            type: "GET",
            url: requestUrl,
            data: { ossUrl: _thisPicUrl },
            dataType: "json",
            async: false,
            contentType: "application/json; charset=utf-8",
            beforeSend: function (request) {
              request.setRequestHeader("token", dataObj.token);
            },
            success: function (data) {

              var _temPicUrl = data.content;
              var uploadImageInfoObj = {
                picType: (i == 1) ? "photoIdFront" : "photoIdReverse",
                picUrl: _temPicUrl,
                base64Image: ""
              };

              _this["idCardPic_" + i] = uploadImageInfoObj;
            },
            error: function (error) {
              $.ajaxError(error);
            }
          });

          var cName = "baiduApiIdentificationNumber_" + i + _this.accountBaseInfo.mobile;
          var cNumber = !!getLocalStorage(cName) ? parseInt(getLocalStorage(cName)) : 1;
          if (cNumber > 5) {
            $("#name,#idNo,#idNoEffect").removeAttr("disabled");
            $.removeWaiting();
          } else {
            //调用百度API识别营业执照信息
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function (e) {

              var base64Image = reader.result;
              var base64ImageShot = base64Image.substring(base64Image.indexOf(",") + 1);
              _this["idCardPic_" + i].base64Image = base64ImageShot;

              var ipc1 = _this.idCardPic_1;
              var ipc2 = _this.idCardPic_2;

              console.log(_this.idCardPic_1)
              console.log(_this.idCardPic_2)

              if (!!ipc1.base64Image && !!ipc2.base64Image) {
                _this.idCardPicBaiduApiIdentification(ipc1.base64Image, ipc2.base64Image, cName, cNumber + 1);
              }
              else {
                $.removeWaiting();
              }
            };
          }
        }
        else {
          $.userAlert("上传失败,请重试!");
          return false;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    idCardPicBaiduApiIdentification(idCardFrontImg, idCardBackImg, cName, cNumber) {

      let _this = this;
      let exp = new Date();
      let h = 24 - exp.getHours();//到23:59结束限制

      exp.setTime(exp.getTime() + h * 60 * 60 * 1000);
      document.cookie = cName + "=" + encodeURI(cNumber) + ";expires=" + exp.toUTCString();

      let requestUrl = _this.requestUrl + "/cust/distinguish/idCard/";
      let reqData = {
        grantType: "client_credentials",
        // clientId: "C3y15Pz7rRDgsg9wIHVYb4pO",
        // clientSecret: "Z90Zlte6WCB14wxh89e9g5HL0KC00NGK",
        clientId: "MMQUV9Ws0fNkSyDEG2OOH3N7",
        clientSecret: "fwThw8l12nrbVZPUbDi5xemvbd0sUHMG",
        idCardFront: idCardFrontImg,
        idCardBack: idCardBackImg,
        detect_direction: "false",
        detect_risk: "false"
      };

      $.ajax({
        type: "POST",
        url: requestUrl,
        data: JSON.stringify(reqData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        beforeSend: function (request) {
          request.setRequestHeader("token", _this.token);
        },
        success: function (data) {

          let code = data.code;
          let content = data.content;

          if (code === 0 && !!content) {
            _this.parameters.legalPersonName = (typeof content.name === "string" && content.name.trim() !== "无") ? content.name : "";
            _this.parameters.legalPersonIdCard = (typeof content.idCard === "string" && content.idCard.trim() !== "无") ? content.idCard : "";
          }

          $("#legalPersonName,#legalPersonIdCard").removeAttr("disabled");
          $.removeWaiting();
        },
        error: function (error) {
          $.ajaxError(error);
        }
      });
    },
    baiduApiIdentification(base64Image, cName, cNumber) {
      let _this = this;
      let exp = new Date();
      let h = 24 - exp.getHours();//到23:59结束限制
      exp.setTime(exp.getTime() + h * 60 * 60 * 1000);
      document.cookie = cName + "=" + encodeURI(cNumber) + ";expires=" + exp.toUTCString();
      let requestUrl = _this.requestUrl + "/cust/distinguish/businessLicense/";
      this.legalPersonNameIdentify = '';
      let reqData = {
        grantType: "client_credentials",
        // clientId: "C3y15Pz7rRDgsg9wIHVYb4pO",
        // clientSecret: "Z90Zlte6WCB14wxh89e9g5HL0KC00NGK",
        clientId: "MMQUV9Ws0fNkSyDEG2OOH3N7",
        clientSecret: "fwThw8l12nrbVZPUbDi5xemvbd0sUHMG",
        image: base64Image,
        detect_direction: "false",
        accuracy: "normal"
      };
      $.ajax({
        type: "POST",
        url: requestUrl,
        data: JSON.stringify(reqData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        beforeSend: function (request) {
          request.setRequestHeader("token", dataObj.token);
        },
        success: function (data) {
          let code = data.code;
          let content = data.content;
          let autoFlag = false;
          if (code === 0) {

            if (typeof content.corpPinNo === "string" && content.corpPinNo.trim() !== "无") {
              _this.parameters.corpPinNo = content.corpPinNo
            } else if ((!content.corpPinNo || content.corpPinNo.trim() === "无") && !!content.credentialNo && content.credentialNo.trim() !== '无') {
              _this.parameters.corpPinNo = content.credentialNo
            }

            // _this.parameters.corpPinNo=(typeof content.corpPinNo==="string" && content.corpPinNo.trim()!=="无")?content.corpPinNo:"";
            _this.parameters.corpName = (typeof content.corpName === "string" && content.corpName.trim() !== "无") ? content.corpName : "";
            _this.adr = (typeof content.address === "string" && content.address.trim() !== "无") ? content.address : "";
            _this.legalPersonNameIdentify = (typeof content.legalPersonName === "string" && content.legalPersonName.trim() !== "无") ? content.legalPersonName : "";
            autoFlag = content.autoFlag;

            // if (!autoFlag) {
            //   $.userAlert('您填写的企业名称与企业信息代码（或注册号）不符，请检查修改后再提交认证')
            // }
            _this.parameters.autoFlag = autoFlag;
          }
          $("#corpName,#corpPinNo").removeAttr("disabled");
          $.removeWaiting();
        },
        error: function (error) {
          $.ajaxError(error);
          $.removeWaiting();
        }
      });
    },

    showThisImg(imgUrl) {
      let _this = this;
      let bigImgObj = $("#upload_img_show");
      let _thisImg = bigImgObj.find("img:eq(0)");
      _thisImg.attr("src", imgUrl);
      bigImgObj
        .fadeIn()
        .find("i")
        .unbind()
        .click(function () {
          bigImgObj.hide();
        })
        .end()
        .unbind()
        .click(function () {
          bigImgObj.hide();
        });
    },
    removeThisImg(i) {
      let imgs = this.parameters.picUrls;
      if (imgs && imgs.length > 0) {
        imgs.splice(i, 1);
      }
    },
    blurInput2(ele) {
      let _this = this;
      let validate = true;
      if (ele === "corpName") {
        let value = _this.parameters[ele];
        validate = value.common_check_corp_name();
        $("#corpName_tips").hide();
      } else if (ele === "corpPinNo") {
        let value = _this.parameters[ele];
        validate = value.common_check_en_num();
        $("#corpPinNo_tips").hide();
      } else if (ele === "adr") {
        let value = _this[ele];
        validate = value.required();
      } else if (ele === "legalPersonName") {
        let value = _this.parameters[ele];
        validate = value.required();
      } else if (ele === "legalPersonIdCard") {
        let value = _this.parameters[ele];
        validate = value.required();
      } else {
        validate = value.required();
      }
      if (!validate) {
        _this["v_" + ele] = true;
      }
      return validate;
    },
    async showConfirmSubmit() {

      let _this = this;
      let confirmResult = 'confirm';

      _this.v_corpPic = false;
      _this.v_idCardPic = false;
      _this.v_pcz = false;

      let reqData = _this.parameters;

      if (reqData.picUrls && reqData.picUrls.length === 0) {
        _this.v_corpPic = true;
        return false;
      }
      if (!_this.blurInput2("corpName")) {
        return false;
      }
      if (!_this.blurInput2("corpPinNo")) {
        return false;
      }
      if (_this.s1v === "0" || _this.s2v === "0" || _this.s3v === "0") {
        _this.v_pcz = true;
        return false;
      }
      if (!_this.blurInput2("adr")) {
        return false;
      }
      if (!_this.idCardPic_1.picUrl || !_this.idCardPic_2.picUrl) {
        _this.v_idCardPic = true;
        return false;
      }
      if (!_this.blurInput2("legalPersonName")) {
        return false;
      }
      if (!_this.blurInput2("legalPersonIdCard")) {
        return false;
      }
      if (reqData.legalPersonName !== this.legalPersonNameIdentify) {
        confirmResult = await this.$confirm(`营业执照备案法人姓名 <b style="font-size:16px">${this.legalPersonNameIdentify || '-'}</b>，与您填写的法人姓名 <b style="font-size:16px">${reqData.legalPersonName || '-'}</b> 不一致，请确定是否继续提交`, { dangerouslyUseHTMLString: true }).catch(() => { })
      }

      if (confirmResult !== 'confirm') return;

      _this.confirmSubmit = true;
    },
    closeConfirmSubmit() {
      let _this = this;
      _this.confirmSubmit = false;
    },
    removeRelativeImg(i) {
      this.picRelativeArr.splice(i, 1)
    },
    removeLegalPersonImage(i) {
      this["idCardPic_" + i] = {};
    },
    uploadRelativeImage() {
      let _this = this;
      var uuid = getCommonId();
      var fileArr = document.getElementById("pic_file_relative");
      var file = fileArr.files[0];
      var type = file.name
        .split(".")[1]
        .trim()
        .toLowerCase();
      if (
        type !== "jpg" &&
        type !== "jpeg" &&
        type !== "png" &&
        type !== "gif" &&
        type !== "bmp"
      ) {
        fileArr.value = "";
        $.userAlert("只能上传jpg、png、gif、bmp格式的图片");
        return false;
      }
      var maxSize = 20 * 1024 * 1024; //20M
      var fileSize = file.size;
      if (fileSize > maxSize) {
        fileArr.value = "";
        $.userAlert("上传的图片不能大于20M");
        return false;
      }
      var dateTime = Date.now().formatOnlyDate();
      var storeAs = "customer/" + dateTime + "/" + uuid + "." + type;
      $.addWaiting("稍等");

      client
        .multipartUpload(storeAs, file)
        .then(function (result) {
          if (result.res.status === 200) {
            var _thisPicType = "BusinessLicenseFrontend";
            var _thisPicUrl = result.res.requestUrls[0];

            let requestUrl = _this.requestUrl + "/user/dealOssUrl";
            $.ajax({
              type: "GET",
              url: requestUrl,
              data: { ossUrl: _thisPicUrl },
              dataType: "json",
              contentType: "application/json; charset=utf-8",
              beforeSend: function (request) {
                request.setRequestHeader(
                  "token",
                  dataObj.token
                );
              },
              success: function (data) {
                var _temPicUrl = data.content;
                var uploadImageInfoObj = {
                  //    picType:_thisPicType,
                  picUrl: _temPicUrl,
                  temPicUrl: _temPicUrl
                };
                _this.picRelativeArr.push(uploadImageInfoObj);
                $.removeWaiting();
              },
              error: function (error) {
                $.removeWaiting();
                $.ajaxError(error);
              }
            });
          } else {
            $.userAlert("上传失败,重试!");
            return false;
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    submit2() {

      let _this = this;
      _this.closeConfirmSubmit();

      // 增加企业相关图片
      for (let i = 0; i < _this.picRelativeArr.length; i++) {
        let obj = {};
        obj.picType = `enterprisePhoto${i + 1}`;
        obj.picUrl = _this.picRelativeArr[i].temPicUrl;
        _this.parameters.picUrls.push(obj);
      }

      //增加身份证照片
      _this.parameters.picUrls.push(_this.idCardPic_1)
      _this.parameters.picUrls.push(_this.idCardPic_2)

      let reqData = _this.parameters;
      let requestUrl = _this.requestUrl + "/cust/corp/auth/";

      for (let i = 0; i < reqData.picUrls.length; i++) {
        delete reqData.picUrls[i].temPicUrl;
      }
      reqData.corpName = reqData.corpName
        .replace("(", "（")
        .replace(")", "）");
      reqData.corpPinNo = reqData.corpPinNo.toUpperCase();
      reqData.location.provinceCode = _this.s1v;
      reqData.location.cityCode = _this.s2v;
      reqData.location.zoneCode = _this.s3v;
      reqData.location.address = _this.adr;

      $.ajax({
        type: "POST",
        url: requestUrl,
        data: JSON.stringify(reqData),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        beforeSend: function (request) {
          $.addWaiting("稍等");
          request.setRequestHeader("token", _this.token);
        },
        success: function (data) {

          let code = data.code;
          let msg = data.msg;

          if (code === 0) {

            _this.step2 = false;
            _this.step3 = true;

            let intervalObj = setInterval(function () {
              _this.link_countDown -= 1;
              if (_this.link_countDown <= 0) {
                _this.link_countDown = 5;
                clearInterval(intervalObj);
                window.location.href = _this.link_to;
              }
            }, 1000);

          } else {
            $.userAlert(msg);
          }
          $.removeWaiting();
        },
        error: function (error) {
          $.ajaxError(error);
        }
      });
    },

    gotoStep3() {
      let _this = this;
      _this.step2 = false;
      _this.step3 = true;
      let intervalObj = setInterval(function () {
        _this.link_countDown -= 1;
        if (_this.link_countDown <= 0) {
          _this.link_countDown = 5;
          clearInterval(intervalObj);
          window.location.href = _this.link_to;
        }
      }, 1000);
    },
    /**获取图形验证资源*/
    getDragVerification() {
      return new Promise((resolve, reject) => {
        getDragVerification().then(res => {
          res = res.data;
          if (res.code === 0) {

            let {
              baseImageUrl,
              sliderImageUrl,
              height,
              taskId,
            } = res.content;
            this.taskId = taskId;

            resolve({
              basePic: baseImageUrl,
              sliderPic: sliderImageUrl,
              picPartPositionY: height
            })

          } else {
            $.userAlert(res.msg);
            reject()
          }
        }).catch(() => {
          $.userAlert('网络错误，请刷新重试');
          reject()
        })
      })
    },
    /**图形验证方法*/
    validate(picCode) {
      return new Promise((resolve, reject) => {
        checkAndSendVerifyCode({
          mobile: this.parameters1.mobile,
          picUUID: this.taskId,
          picCode
        }).then(res => {
          res = res.data;
          if (res.code === 0) {
            this.loginVerifyControl(false)
            this.countDownFun('mobile');
            resolve()
            $.userAlert('验证码已发送');
          } else {
            $.userAlert(res.msg);
            reject()
          }
        }).catch(() => {
          $.userAlert('网络错误，请刷新重试');
          reject()
        })
      })
    },
    /**登录验证控制*/
    loginVerifyControl(data) {
      this.loginVerifyShow = data;
    },
  },
  created() { },
  mounted() {
    $.pageWaiting();
    let _this = this;
    if (typeof _this.token === "string" && _this.token !== "") {
      window.location.href = "user_index.html";
    }
    window.onload = function () {
      let rndNum = getCommonId();
      let gSrc = "//g.alicdn.com/sd/ncpc/nc.js?t=" + rndNum;
      loadScript(gSrc, function () {
        setTimeout(function () {
          $("#register_component").animate({ opacity: 1 }, 500);
          $.removePageWaiting();
        }, 500);
        loadScript(
          "https://qiyukf.com/script/debae06a181a195ea71396d3f3933069.js?hidden=1",
          function () { }
        );
      });
      // setTimeout(function() {
      //     $("b._common_select").each(function () {
      //         var $this = $(this);
      //         var contentObj = $("<a></a>");
      //         var arrowObj = $("<i></i>").addClass("fa").addClass("fa-caret-down");
      //         $this.append(contentObj).append(arrowObj);
      //         var selectObj = $this.children("select");
      //         var defaultValue = selectObj.children("option:selected").text();
      //         contentObj.html(defaultValue);
      //         selectObj.change(function () {
      //             var newValue = $(this).children("option:selected").text();
      //             contentObj.html(newValue);
      //         });
      //     })
      // });
      // $("#s1v").change(function(){
      //     console.log(1)
      //     dataObj.s2v="0";
      //     dataObj.s3v="0";
      //     $("#s2v").prop("value","0").change();
      //     $("#s3v").prop("value","0").change();
      // });
      // $("#s2v").change(function(){
      //     console.log(2)
      //     dataObj.s3v="0";
      //     $("#s3v").prop("value","0").change();
      // });
    };
  }
};
</script>
<style>
._register_bg {
  background-image: url("~images/register_bg.jpg");
  opacity: 0;
}

._register_header {
  width: 100%;
  border-bottom: solid 1px #dedede;
  background-color: #fff;
}

._register_header_container {
  clear: both;
  width: 1200px;
  height: 68px;
  margin: 0 auto;
  position: relative;
}

._register_header_container > img {
  display: inline-block;
  height: 58px;
  margin-top: 5px;
}

._register_header_container > b {
  display: inline-block;
  font-size: 1.4rem;
  margin-left: 10px;
  padding-left: 10px;
  color: #333;
  font-weight: normal;
  border-left: solid 1px #333;
  position: relative;
  top: -22px;
}

._register_header_container > a {
  display: inline-block;
  font-size: 1.4rem;
  color: #333;
  text-decoration: underline;
  position: absolute;
  top: 26px;
  right: 0px;
}

._register_frame {
  width: 30%;
  margin: 0 auto;
  background-color: #fff;
  box-shadow: 0px 0px 10px 0px #ddd;
  position: relative;
}

._register_form_container {
  width: 80%;
  margin: 0 auto;
  padding: 20px 0px;
}

._operate_step {
  width: 65%;
  margin: 0 auto;
}

._operate_step > table {
  width: 100%;
}

._operate_step > table td {
  height: 24px;
  text-align: center;
  background-image: url("~images/_step_line_n.png");
  background-position: left center;
  background-repeat: repeat-x;
}

._operate_step > table td > ._step_dot {
  display: inline-block;
  width: 24px;
  height: 24px;
  text-align: center;
  line-height: 24px;
  border-radius: 16px;
  color: #ffffff;
  border: solid 4px #ebeced;
  background-color: #bbbbbb;
}

._operate_step > table td._ok {
  background-image: url("~images/_step_line_s.png");
}

._operate_step > table td._ok > ._step_dot {
  border: solid 4px #d7e4f4;
  background-color: #2f81e8;
}

._operate_step > table th {
  font-size: 1.2rem;
  font-weight: normal;
}

/*by_wxw*/
._verified_upload_image {
  clear: both;
  width: 100%;
  position: relative;
  height: auto;
}

._verified_upload_image ._file_container {
  display: inline-block;
  width: 58px;
  height: 58px;
  border: dashed 1px #d8d8d8;
  background-color: #f3f4fd;
  margin-right: 10px;
  position: relative;
}

._verified_upload_image ._file_container > img {
  display: inline-block;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 110;
}

._verified_upload_image ._file_container > b {
  display: inline-block;
  width: 100%;
  padding-top: 15px;
  text-align: center;
  color: #aaa;
  font-weight: normal;
  font-size: 1.2rem;
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 111;
}

._verified_upload_image ._file_container > input[type="file"] {
  display: inline-block;
  width: 100%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 112;
}

._verified_upload_image ._file_container > i {
  display: inline-block;
  width: 16px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  border-radius: 10px;
  font-style: normal;
  font-size: 1.6rem;
  color: #fff;
  border: solid 2px #fff;
  background: #fe3a5e;
  position: absolute;
  right: -7px;
  top: -7px;
  z-index: 113;
  cursor: pointer;
}
._verified_upload_idcard_pic {
  clear: both;
  width: 100%;
  position: relative;
}
._verified_upload_idcard_pic ._file_container {
  display: inline-block;
  width: 84px;
  height: 58px;
  border: dashed 1px #d8d8d8;
  background-color: #f3f4fd;
  margin-right: 10px;
  position: relative;
}
._verified_upload_idcard_pic ._file_container > img {
  display: inline-block;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 110;
}
._verified_upload_idcard_pic ._file_container > b {
  display: inline-block;
  width: 100%;
  padding-top: 15px;
  text-align: center;
  color: #fff;
  font-weight: normal;
  font-size: 1.2rem;
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 111;
}
._verified_upload_idcard_pic ._file_container > b > i {
  color: #fff;
  font-size: 1.6rem;
}
._verified_upload_idcard_pic ._file_container > input[type="file"] {
  display: inline-block;
  width: 100%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 112;
}
._verified_upload_idcard_pic ._file_container > i {
  display: inline-block;
  width: 16px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  border-radius: 10px;
  font-style: normal;
  font-size: 1.6rem;
  color: #fff;
  border: solid 2px #fff;
  background: #fe3a5e;
  position: absolute;
  right: -7px;
  top: -7px;
  z-index: 113;
  cursor: pointer;
}
._common_form_row > b._common_select > select {
  opacity: 1 !important;
}
.step2 ._common_form_row {
  margin-bottom: 14px;
}
.pass_btn {
  text-align: center;
  color: #999;
  font-size: 14px;
  cursor: pointer;
  width: 80px;
  margin: 10px auto 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/component/sign/Register.vue